import { AgentGlyph, agentGlyphColor, type AgentGlyphExpression } from "@/product-stage/AgentGlyph.tsx";
import type { ReplicaAgent } from "@/product-stage/demo/types.ts";
import { EXCEL_AGENT_ID, KNOWLEDGE_AGENT_ID } from "@/product-stage/demo/world.ts";

const BACKDROPS: readonly {
  id: string;
  slot: "left" | "right";
  expression: AgentGlyphExpression;
}[] = [
  { id: KNOWLEDGE_AGENT_ID, slot: "left", expression: "thinking" },
  { id: EXCEL_AGENT_ID, slot: "right", expression: "happy" }
];

export function HeroAgents({
  agents,
  reducedMotion
}: {
  agents: readonly ReplicaAgent[];
  reducedMotion: boolean;
}) {
  return (
    <div className="hero-agents" aria-hidden="true">
      {BACKDROPS.map((item) => {
        const agent = agents.find((candidate) => candidate.id === item.id);
        if (!agent) return null;
        const expression = agent.status === "working" ? "thinking" : item.expression;
        return (
          <div
            key={agent.id}
            className="hero-agent"
            data-slot={item.slot}
            style={{ color: agentGlyphColor(agent.seed) }}
          >
            <span className="hero-agent-glow" />
            <AgentGlyph seed={agent.seed} expression={expression} animated={!reducedMotion} />
          </div>
        );
      })}
    </div>
  );
}
